export default __webpack_public_path__ + "static/media/banner_grad.d0fb0ad8.png";